import React, { useContext } from "react";
import { Outlet } from "react-router-dom";

import Navbar from "../components/Navbars/Navbar";
import { ToastContainer } from "react-toastify";
import { UserContext } from "../lib/MainContext";
import { isEmpty } from "lodash";

const View = () => {
    const { user: currentUser } = useContext(UserContext);

    if (isEmpty(currentUser)) return <></>;
    return (
        <>
            <Navbar />

            {/* Main Content */}
            <main
                className="main-content-full-view"
                id="main-content-full-view"
            >
                <Outlet />
            </main>
            <ToastContainer limit={3} />
        </>
    );
};

export default View;
